import { render, staticRenderFns } from "./CreateBtn.vue?vue&type=template&id=7f95edfe"
import script from "./CreateBtn.vue?vue&type=script&lang=js"
export * from "./CreateBtn.vue?vue&type=script&lang=js"
import style0 from "./CreateBtn.vue?vue&type=style&index=0&id=7f95edfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports